/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// https://splidejs.com/tutorials/image-slider/

document.addEventListener('DOMContentLoaded', function () {
	const sliderElement3 = document.querySelector(".customsplide");
	if (sliderElement3) {
		var splideni = new Splide(sliderElement3, {
			type: 'loop', // slide loop fade
			perPage: 1,
			autoplay: 1,
			arrows: false,
		});
		splideni.mount();
		const pagination = document.querySelector('.customsplide .splide__pagination');
		if (pagination) {
			const btnNext = document.createElement('li');
			btnNext.id = 'btnNext';
			pagination.insertBefore(btnNext, pagination.firstChild);

			// Insert at the end
			const btnPrev = document.createElement('li');
			btnPrev.id = 'btnPrev';
			pagination.appendChild(btnPrev);

			// Add event listeners
			btnNext.addEventListener('click', function () {
				splideni.go('-1');
			});

			btnPrev.addEventListener('click', function () {
				splideni.go('+1');
			});
		}
	}
});
